import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

export const BrandLink = styled.a`
  font-family: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 16px;
`;

export const DepositInfoText = styled.span`
  display: inline-block;
  inline-size: 90%;
  overflow-wrap: break-word;
  hyphens: auto;
`;

export const CancellationPolicyText = styled.span`
  display: block;
  inline-size: ${(props) =>
    props.inlineSize ? `${props.inlineSize}%` : '90%'};
  padding-right: 10px;
  min-width: fit-content;
`;
